'use strict';

/** Må samsvare med `$s` i src/styles/abstracts/_variables.scss */
const MOBILE_NAV_MAX_PX = 900;

const htmlEl = document.documentElement;
const navToggle = document.getElementById('navToggle');
const siteNav = document.getElementById('site-navigation');

const NAV_OPEN_CLASS = 'nav-open';

const isNavOpen = () => htmlEl.classList.contains(NAV_OPEN_CLASS);

const openNav = () => {
	htmlEl.classList.add(NAV_OPEN_CLASS);
	if (navToggle) {
		navToggle.setAttribute('aria-expanded', 'true');
		navToggle.setAttribute('aria-label', navToggle.dataset.labelClose || 'Close menu');
	}
	document.addEventListener('keydown', onEscape);
};

const closeNav = () => {
	htmlEl.classList.remove(NAV_OPEN_CLASS);
	if (navToggle) {
		navToggle.setAttribute('aria-expanded', 'false');
		navToggle.setAttribute('aria-label', navToggle.dataset.labelOpen || 'Open menu');
	}
	document.removeEventListener('keydown', onEscape);
};

const onEscape = (e) => {
	if (e.key === 'Escape') {
		closeNav();
	}
};

if (navToggle && siteNav) {
	navToggle.dataset.labelOpen = navToggle.getAttribute('aria-label') || '';
	navToggle.dataset.labelClose = 'Close menu';

	navToggle.addEventListener('click', () => {
		if (isNavOpen()) {
			closeNav();
		} else {
			openNav();
		}
	});

	// Close on link click (mobile)
	siteNav.querySelectorAll('a').forEach((link) => {
		link.addEventListener('click', () => {
			if (window.matchMedia(`(max-width: ${MOBILE_NAV_MAX_PX}px)`).matches) {
				closeNav();
			}
		});
	});

	window.addEventListener('resize', () => {
		if (window.matchMedia(`(min-width: ${MOBILE_NAV_MAX_PX + 1}px)`).matches) {
			closeNav();
		}
	});
}
